import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto 1rem;
  h1 {
      margin-bottom: 24px;
  }
`;

export const PieChartsContainer = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-rows: repeat(3, 32%);
  justify-content: center;
  margin-bottom: 2rem;

  @media screen and (min-width: 540px) {
    grid-template-rows: 1;
    grid-template-columns: repeat(2, 40%);
  }
`;

export const Column = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 320px;

  span {
    text-align: center;
  }
`;

export const ChartLabel = styled.span`
  font-weight: bold;
  font-size: 1rem;
`;
